var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,512) scale(0.1,-0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M855.5,4641.7c-184.8-49.2-329.1-196.8-378.3-383.8c-25.1-94-25.1-3301.9,0-3396c49.2-189.2,194.6-335.7,382.7-384.9 c56.9-14.2,266.8-16.4,1700.2-16.4s1643.3,2.2,1700.2,16.4c188.1,49.2,333.5,195.7,382.7,384.9c25.1,94,25.1,3301.9,0,3396 c-49.2,189.2-194.6,335.7-382.7,384.9C4165,4666.8,947.3,4666.8,855.5,4641.7z M4228.5,4280.9c16.4-12,40.5-36.1,52.5-52.5 c21.9-28.4,23-45.9,26.2-412.2l3.3-381.6H2560H810.6v365.2c0,379.4,2.2,404.5,47,453.7c53.6,57.9-32.8,54.7,1715.5,52.5 C4195.7,4303.8,4198.9,4303.8,4228.5,4280.9z M1685.3,2603.7v-481.1H1248H810.6v481.1v481.1H1248h437.3V2603.7z M3084.8,2603.7 v-481.1H2560h-524.8v481.1v481.1H2560h524.8V2603.7z M4309.4,2603.7v-481.1H3872h-437.3v481.1v481.1H3872h437.3V2603.7z  M1685.3,1291.6V809.5l-381.6,3.3C937.5,816,920,817.1,891.5,839c-16.4,12-40.5,36.1-52.5,52.5c-21.9,28.4-23,44.8-26.2,455.9 l-3.3,425.3H1248h437.3V1291.6z M3084.8,1291.6V810.6H2560h-524.8v481.1v481.1H2560h524.8V1291.6z M4307.2,1347.4 c-3.3-411.1-4.4-427.5-26.2-455.9c-12-16.4-36.1-40.5-52.5-52.5c-28.4-21.9-45.9-23-412.2-26.2l-381.6-3.3v482.2v481.1H3872h438.4 L4307.2,1347.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.30ab75bb73d65d010f3ecb9433bf5245.svg";
export { ForwardRef as ReactComponent };